import { createAction } from 'redux-actions'

export const addProduct = createAction('PRODUCT_ADDED')
export const removeProduct = createAction('PRODUCT_REMOVED')
export const clearOrder = createAction('ORDER_CLEARED')

export const getOrderSummary = createAction('GET_ORDER_SUMMARY_STARTED')
export const getOrderSummarySuccess = createAction('GET_ORDER_SUMMARY_SUCCEED')
export const getOrderSummaryFail = createAction('GET_ORDER_SUMMARY_FAILED')

export const createOrder = createAction('CREATE_ORDER_STARTED')
export const createOrderSuccess = createAction('CREATE_ORDER_SUCCEED')
export const createOrderFail = createAction('CREATE_ORDER_FAILED')

export const changeSelectedDeliveryDay = createAction(
  'SELECTED_DELIVERY_DAY_CHANGED'
)
export const changeSelectedDeliveryTime = createAction(
  'SELECTED_DELIVERY_TIME_CHANGED'
)
export const setZipcode = createAction('ZIPCODE_SET')

export const changeTip = createAction('SELECTED_TIP_CHANGED')

export const changeDropoff = createAction('DROPOFF_CHANGED')

export const changeSelectedAddress = createAction('SELECTED_ADDRESS_CHANGED')

export const changeSelectedCard = createAction('SELECTED_CARD_CHANGED')

export const changeNote = createAction('NOTE_CHANGED')

export const changeCoupon = createAction('COUPON_CHANGED')

export const applyCoupon = createAction('APPLY_COUPON_STARTED')
export const applyCouponSuccess = createAction('APPLY_COUPON_SUCCEED')
export const applyCouponFail = createAction('APPLY_COUPON_FAILED')



// WEBPACK FOOTER //
// ./src/store/actions/order.js